import React, { useState } from 'react';
import Icon from '../../images/arrow.svg';
import emailjs from 'emailjs-com';

const CalculationForm = ({ SectionTitleShow = false }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    product: '',
    quantity: '',
    consumerType: '',
    city: '',
    state: '',
  });

  const [errors, setErrors] = useState({});
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = 'Full Name required';
    if (!formData.email) {
      newErrors.email = 'Email required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Invalid email address';
    }
    if (!formData.phone) newErrors.phone = 'Phone required';
    if (!formData.product) newErrors.product = 'Select a Product';
    if (!formData.quantity) newErrors.quantity = 'Select Quantity';
    if (!formData.consumerType) newErrors.consumerType = 'Select Consumer Type';
    if (!formData.city) newErrors.city = 'Enter City';
    if (!formData.state) newErrors.state = 'Enter State';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      setSubmitStatus('error');
      return;
    }

    const serviceID = 'service_25h0nis';
    const adminTemplateID = 'template_bc2yio8'; // existing admin template
    const userTemplateID = 'template_iuxgt0o'; //  your thank-you template ID
    const publicKey = 'dEios7zcNaamY5e4u';

    try {
      // 1️⃣ Send email to Admin
      await emailjs.send(serviceID, adminTemplateID, formData, publicKey);

      // 2️⃣ Send thank-you email to User
      await emailjs.send(serviceID, userTemplateID, formData, publicKey);

      console.log('✅ Emails sent successfully!');
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        product: '',
        quantity: '',
        consumerType: '',
        city: '',
        state: '',
      });
    } catch (error) {
      console.error('❌ Error sending email:', error);
      setSubmitStatus('error');
    }
  };

  return (
    <div className="wpo-contact-form-area">
      {SectionTitleShow && (
        <div className="wpo-section-title">
          <span>Get A Quote</span>
          <h2>Easy to check your product transportation price.</h2>
        </div>
      )}

      <form onSubmit={handleSubmit} className="contact-validation-active">
        <div className="personal-info">
          <h5>PERSONAL INFO:</h5>
          <div className="row">
            <div className="form-group col-lg-4 col-md-6 col-12 mt-3">
              <input
                type="text"
                name="name"
                placeholder="Your Name*"
                className="form-control"
                value={formData.name}
                onChange={handleChange}
              />
              {errors.name && <div className="error">{errors.name}</div>}
            </div>
            <div className="form-group col-lg-4 col-md-6 col-12 mt-3">
              <input
                type="email"
                name="email"
                placeholder="Your Email*"
                className="form-control"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <div className="error">{errors.email}</div>}
            </div>
            <div className="form-group col-lg-4 col-md-6 col-12 mt-3">
              <input
                type="text"
                name="phone"
                placeholder="Phone"
                className="form-control"
                value={formData.phone}
                onChange={handleChange}
              />
              {errors.phone && <div className="error">{errors.phone}</div>}
            </div>
          </div>
        </div>

        <div className="shipt-info">
          <h5>PRODUCT INFO:</h5>
          <div className="row">
            <div className="form-group col-lg-4 col-md-6 col-12 mt-3">
              <select
                name="product"
                className="form-control"
                value={formData.product}
                onChange={handleChange}
              >
                <option value="">Select Product</option>
                <option>Water Tank</option>
                <option>PP Fabric</option>
                <option>PP Woven Bag</option>
                <option>BOPP Multicolor Bag</option>
                <option>PP Laminated Kraft</option>
                <option>Leno Bag</option>
                <option>Corrugated Box</option>
              </select>
              {errors.product && <div className="error">{errors.product}</div>}
            </div>

            <div className="form-group col-lg-4 col-md-6 col-12 mt-3">
              <select
                name="quantity"
                className="form-control"
                value={formData.quantity}
                onChange={handleChange}
              >
                <option value="">Select Quantity</option>
                <option>1 - 10</option>
                <option>11 - 25</option>
                <option>26 - 50</option>
                <option>Bulk Order</option>
              </select>
              {errors.quantity && <div className="error">{errors.quantity}</div>}
            </div>

            <div className="form-group col-lg-4 col-md-6 col-12 mt-3">
              <select
                name="consumerType"
                className="form-control"
                value={formData.consumerType}
                onChange={handleChange}
              >
                <option value="">Consumer Type</option>
                <option>Customer</option>
                <option>Reseller</option>
                <option>Business</option>
              </select>
              {errors.consumerType && <div className="error">{errors.consumerType}</div>}
            </div>

            <div className="form-group col-lg-4 col-md-6 col-12 mt-3">
              <input
                type="text"
                name="city"
                placeholder="City"
                className="form-control"
                value={formData.city}
                onChange={handleChange}
              />
              {errors.city && <div className="error">{errors.city}</div>}
            </div>

            <div className="form-group col-lg-4 col-md-6 col-12 mt-3">
              <input
                type="text"
                name="state"
                placeholder="State"
                className="form-control"
                value={formData.state}
                onChange={handleChange}
              />
              {errors.state && <div className="error">{errors.state}</div>}
            </div>
          </div>
        </div>

        <div className="submit-area">
          <button type="submit" className="theme-btn mt-5 mb-5">
            GET A QUOTE <i><img src={Icon} alt="" /></i>
          </button>
        </div>

        <div className="clearfix error-handling-messages">
          {submitStatus === 'success' && <div id="c-success">✅ Thank you! Your request has been sent.</div>}
          {submitStatus === 'error' && <div id="c-error">❌ Please fill all fields correctly.</div>}
        </div>
      </form>
    </div>
  );
};

export default CalculationForm;
